ClickElseWhereMixin = require 'mixins/click-else-where'

App.ExpandableImageComponent = Em.Component.extend ClickElseWhereMixin,
  tagName: 'img'
  attributeBindings: ['src', 'alt', 'title']
  classNames: ['expandable']
  isOpen: false

  didInsertElement: ->
    console.log 'here'
    @addStyleForFullscreen()

  click: (event) ->
    $image = @$()
    if $image.hasClass('fullscreen')
      $image.removeClass('fullscreen')
      @set('isOpen', false)
    else
      $image.addClass('fullscreen')
      $('body').css('overflow', 'hidden')
      @set('isOpen', true)

  onClickElsewhere: ->
    $image = @$()
    $image.removeClass('fullscreen')
    @set('isOpen', false)

  addStyleForFullscreen: ->
    unless $('#fullscreen-style').length
      $style = $('<style>', { id: 'fullscreen-style' })
      $style.text("""
        .fullscreen {
          position: fixed;
          top: 0;
          left: 50%;
          transform: translatex(-50%);
          min-width: 800px;
          min-height: 800px;
          object-fit: contain !important;
          object-position: center;
          z-index: 1000;
          background-color: rgba(0, 0, 0, 0.8);
          cursor: zoom-out;
        }
      """)
      $('head').append($style)
